app.service('checkSameDayMessage', function (loading, modal, front) {

	function check(sameDayMessage, callback, next) {
		function accountChangeDelivery() {
			callback();
			loading.start();
			$.ajax({
				type: 'POST',
				url: '/customer-order-delivery-time.ltr',
				data: {
					ACTION: "CHANGE_PAYMENT"
				},
				success: function (json) {
					if (json.status == 'SUCCESS') {
						next();
					} else {
						modal.alert('Błąd zmiany typy płatności. Proszę spróbować później', function () {
							loading.reload();
						});
					}
				},
				error: function () {
					modal.alert('Błąd zmiany typy płatności', function () {
						loading.reload();
					});
				}
			});
		}
		function changePaymentTypeForSameDayDeliveryType() {
			callback();
			loading.start();
			$.ajax({
				url: '/order-path-change-payment-type.ltr',
				dataType: 'json',
				type: 'POST',
				data: {
					refresh: true
				},
				success: function () {
					loading.stop();
					next();
				},
				error: function () {
					modal.alert('Błąd zmiany typy płatności', function () {
						loading.reload();
					});
				}
			});
		}

		if (sameDayMessage) {
			modal.generate({
				content: sameDayMessage,
				buttons: [
					{
						text: 'Wybieram inny termin dostawy',
						cssClass: 'btn-third js-close-modal'
					}, {
						text: 'Zapłacę przy odbiorze',
						cssClass: 'btn-primary js-close-modal',
						click: function () {
							if (front.group() == 'account') {
								accountChangeDelivery();
							} else {
								changePaymentTypeForSameDayDeliveryType();
							}

						}
					}
				]
			});
			return true;
		}
		return false;
	}

	return {
		check
	};
});
